import "bootstrap/dist/css/bootstrap.css";
import LogRocket from 'logrocket';
import React, { Component } from "react";
import { AuthenticationState, AzureAD } from "react-aad-msal";
import { Button } from "reactstrap";
import { authProvider } from "../../AuthProvider";
import { AzureBackupAccountProgress } from "../AzureBackupAccountProgress";
import { SecurityAndPrivacy } from "../SecurityAndPrivacy";
import { SubscriberAgreement } from "../SubscriberAgreement";
import decryptParameter from "../../Helpers/DeCryptParameter";
export class AzureBackupAccount extends Component {
  constructor(props) {
      super(props);
      const urlParams = new URLSearchParams(window.location.search);
      const orgId = decryptParameter(urlParams.get('orgId'));
        this.state = {
            theme: null,
            orgId: orgId
        };
  }
    static displayName = AzureBackupAccount.name;

  render() {
    const WidgetTheme = React.lazy(() => import('../ThemeObjects/WidgetTheme'));
    let chosenTheme = <WidgetTheme/>
    let returnObject = (
    <div style={{backgroundImage: "none", backgroundColor: "white"}}>
      <React.Suspense fallback={<></>}>
        {chosenTheme}
      </React.Suspense>     
      <AzureAD provider={authProvider} forceLogin={true}>
        {({ login, logout, authenticationState, error, accountInfo }) => {
          switch (authenticationState) {
            case AuthenticationState.Authenticated:
              LogRocket.identify(accountInfo.account.userName, {
                name: accountInfo.account.name
              });
              return (
                  <React.Fragment>
                      <AzureBackupAccountProgress token={accountInfo.token} page={true} orgId={this.state.orgId} />
                </React.Fragment>
              );
            case AuthenticationState.Unauthenticated:
              if (error) {
                if(error.errorCode){
                  if(error.errorCode === "user_cancelled"){
                    return (
                      <React.Fragment>
                        <p>
                          Authentication Error. Please log out and try again.
                        </p>
                        <Button onClick={logout}>Log Out</Button>
                      </React.Fragment>
                    );
                  } else {
                    return (
                      <React.Fragment>
                        <p>
                          Authentication Error. Please log out and try again.
                        </p>
                        <Button onClick={logout}>Log Out</Button>
                      </React.Fragment>
                    ); 
                  }
                } else {
                  return (
                    <React.Fragment>
                        <p>
                          Authentication Error. Please log out and try again.
                        </p>
                        <Button onClick={logout}>Log Out</Button>
                      </React.Fragment>
                  ); 
                }                           
              } else {
                return (
                  <React.Fragment>
                    <p>
                      Please Log In
                    </p>
                    <Button onClick={login}>Log In</Button>
                  </React.Fragment>
                );
              }
            case AuthenticationState.InProgress:
              return (
                <React.Fragment>
                  <p>
                    Authenticating with Microsoft.
                  </p>
                </React.Fragment>
              );
            default:
              return <p>Error.</p>;
          }
        }}
      </AzureAD>
    </div>      
    );
      const currentYear = new Date().getFullYear(); 

    return(<div id="ContentPlaceHolder1_UpdatePanel1">
    <div className="row login">
      <div className="col"></div>
      <div className="col-xs-12 col-sm-8 col-md-6 col-lg-5 col-xl-3 text-center">
        <div className="card loginbox">
          <div className="card-body">
            {returnObject}
          </div>
          <div className="card-footer">
            <section className="small">
              <SubscriberAgreement />
              |
                            <SecurityAndPrivacy />
                            <br />© Virtual Data Centre Services Limited {currentYear}
            </section>
          </div>
          <span
            id="ContentPlaceHolder1_lblLoginResponse"
            style={{ color: "red" }}
          ></span>
        </div>
      </div>
      <div className="col"></div>
    </div>
  </div>);
  }
}